<template>
  <div
    class="qa-wrap"
    v-if="isShow"
    v-track="{
      act: 'show',
      params: { cfrom: '182|001|02|077', event_id: '182|001|02|077', page_name: 1, sku_id: skuId }
    }"
  >
    <template v-if="curSkuQuestions">
      <!-- 标题 -->
      <v-list-view
        class="qa-list-wrapper"
        name="问答"
        :sub-name="total"
        :type="2"
        right-text="查看全部"
        @click="goToAnswer"
        right-icon="arrow-right-v3"
      >
        <!-- 问答列表 -->
        <div class="qa-list" tabindex="0" @click="goToAnswer">
          <div class="item" v-for="(item, index) in curSkuQuestionList" :key="index">
            <div class="title">
              <div class="question">问</div>
              <span class="des">{{ item.question }}</span>
            </div>
            <div class="num">
              <span v-if="item.ansNum">{{ item.ansNum }}个回答</span>
              <span v-else>暂无回答</span>
            </div>
          </div>
        </div>
      </v-list-view>
    </template>
    <template v-else>
      <div class="none-question" tabindex="0" aria-label="暂无问答-问大家-商品好不好，问问买过的人">
        <div class="box-title">
          <span class="title" aria-hidden="true">暂无问答</span>
        </div>
        <div class="qa-list">
          <div class="item q-none">
            <div class="title">
              <div class="icon" aria-hidden="true">
                <span class="fs-30">问大家</span>
              </div>
              <span class="des" aria-hidden="true">商品好不好，问问买过的人</span>
            </div>
            <div>
              <v-button size="small" type="frame" @click="goToAnswer">去提问</v-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { formatCount } from '@/utils/common'
import { mapGetters } from 'vuex'
import { getQuestionList } from '../../index/api'
import { app } from '@/utils'

export default {
  name: 'Qa',
  computed: {
    ...mapGetters('detailv3', ['spuId', 'skuId']),
    total() {
      return this.curSkuQuestions.total ? `（${formatCount(this.curSkuQuestions.total)}）` : ''
    }
  },
  data() {
    return {
      // 问答信息
      questionInfo: '',
      curSkuQuestions: '', // 当前sku问答信息
      curSkuQuestionList: [],
      isShow: true
    }
  },
  mounted() {
    this.getQuestionInfo()
  },
  watch: {
    // 监听skuId变化，重置当前sku问答
    skuId(val) {
      if (val) {
        this.setCurSkuQA(val)
      }
    }
  },
  methods: {
    // 获取spu下所有sku问答信息, 然后根据skuId匹配当前问答信息
    getQuestionInfo() {
      let param = {
        spuId: this.spuId,
        pageNum: 1,
        sortOrder: 'hot',
        firstScreen: true // 区分商详页、问答列表页，true商详页，false问答列表页
      }
      getQuestionList(param)
        .then(data => {
          this.questionInfo = data || []
          this.setCurSkuQA(this.skuId)
        })
        .catch(err => {
          // 降级兼容
          this.isShow = false
        })
    },
    // 设置当前sku问答信息
    setCurSkuQA(skuId) {
      this.curSkuQuestions = ''
      this.curSkuQuestionList = []
      // 解决回退时优先触发watch问题
      if (!this.questionInfo) {
        this.getQuestionInfo()
        return
      }
      this.questionInfo.forEach(item => {
        if (item.skuId === skuId) {
          this.curSkuQuestions = item.questions
          this.curSkuQuestionList = item.questions?.list || []
        }
      })
    },
    // 跳转问答列表页
    goToAnswer() {
      this.$track({
        cfrom: '182|001|01|077',
        event_id: '182|001|01|077',
        page_name: 1,
        sku_id: this.skuId
      })
      app.openNewWebview({
        url: `${this.linkBase}/product/qa/list?spuId=${this.spuId}&skuId=${this.skuId}`
      })
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
